/**
 * App shell. Two layouts, switched at the desktop breakpoint (useIsDesktop):
 *
 *  - Phone / tablet (< 1024px): the original app layout — fullscreen navy/gold
 *    background (app-bg), a 430px content column, and the BottomNav tab bar.
 *  - Desktop (>= 1024px): website layout — fixed SideNav plus a wide content
 *    area. Dashboard-style routes (WIDE_ROUTES: home, progress, calendar,
 *    coach) get up to 1200px so charts and multi-column pages have room;
 *    everything else (forms, lists, settings) stays in a readable 760px column.
 *
 * Screens render their own PageHeader.
 */

import { Outlet, useLocation } from 'react-router';
import { BottomNav } from './BottomNav';
import { SideNav } from './SideNav';
import { useIsDesktop } from '@/lib/useIsDesktop';

const WIDE_ROUTES = ['/home', '/calendar', '/coach/', '/profile/messages'];

function isWide(pathname: string): boolean {
  if (pathname === '/home/appointments') return false;
  return WIDE_ROUTES.some((p) => pathname === p || pathname.startsWith(p.endsWith('/') ? p : `${p}/`));
}

export default function AppShell() {
  const isDesktop = useIsDesktop();
  const { pathname } = useLocation();

  if (isDesktop) {
    return (
      <div className="app-bg desktop-shell">
        <SideNav />
        <main className="desktop-main">
          <div style={{ width: '100%', maxWidth: isWide(pathname) ? 1200 : 760, margin: '0 auto', minWidth: 0 }}>
            <Outlet />
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="page-content app-bg">
      <div style={{ width: '100%', maxWidth: 430, margin: '0 auto', minWidth: 0, overflowX: 'hidden' }}>
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}
